<div id="SEOB" class="home-tab-container">
  <input id="tab-one-bike" type="radio" name="grp2" checked="checked" />
  <label for="tab-one-bike">Overview</label>
  <div id="overview" class="home-tab-content overview">
    <div>
      <div class="ins-heading pt-10">
        <h1 class="aem-header">Bike Insurance Premium Calculator Online
        </h1>
      </div>
      <div class="ins-answer pt-10">
        <p>Choosing the right bike insurance plan is important to get the best kind of protection for the rider and
          his vehicle. In such a situation, an online bike insurance calculator can be immensely helpful in making the
          right choice. The bike insurance premium calculator is an effective online tool that allows you to compare
          from various insurance providers. It can also help understand the various features and benefits that a
          particular bike insurance comes with. You can use the online bike insurance calculator on this page to get
          the plan for your two-wheeler.
        </p>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">How is Bike Insurance Premium Calculated</h2>
      </div>
      <div class="ins-answer pt-10">
        <p>Bike insurance premium is calculated on the basis of factors like its engine capacity, age of the vehicle,
          etc. The table below will give you an idea of how bike insurance premiums are calculated, as per guidelines
          given by the Insurance Regulatory Authority of India:
        </p>
      </div>
      <table id="bagic-faq" class="table table-bordered benefit-table">
        <tbody>
          <tr>
            <th class="head-width content-align-left table-header">
              Two Wheeler Category
            </th>
            <th class="head-width content-align-right table-header">
              Premiums
            </th>
          </tr>
          <tr>
            <td class="content-align-left">
              Vehicles not exceeding 75cc in power
            </td>
            <td class="content-align-right">
              ₹482
            </td>
          </tr>
          <tr>
            <td class="content-align-left">
              Vehicles exceeding 75cc but not exceeding 150cc
            </td>
            <td class="content-align-right">
              ₹752
            </td>
          </tr>
          <tr>
            <td class="content-align-left">
              Vehicles exceeding 150cc but not exceeding 350cc
            </td>
            <td class="content-align-right">
              ₹1193
            </td>
          </tr>
          <tr>
            <td class="content-align-left">
              Vehicles exceeding 350cc in power
            </td>
            <td class="content-align-right">
              ₹2323
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ins-answer pt-10">
        <p>It should be noted that other factors like location, model and price of the vehicle and the age of the
          vehicle may also affect insurance prices. You can get a good idea of base third-party insurance rates for
          bikes using the table above.
        </p>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">How to Use Two Wheeler Insurance Premium Calculator Online
        </h2>
      </div>
      <div class="ins-answer pt-10">
        <p>Just follow these 5 quick steps to calculate your bike insurance premium using two wheeler third party
          insurance premium calculator:
        </p>
      </div>
      <div class="ins-answer pt-10">
        <p><strong>Step 1:</strong> Begin by providing your vehicle&rsquo;s details such as the registration
          number.&nbsp;</p>
        <p><strong>Step 2:</strong> Proceed further to provide the details of its make &amp; model, fuel type,
          registration details, and more.</p>
        <p><strong>Step 3:</strong> Declare the NCB (no claim bonus) status</p>
        <p><strong>Step 4:</strong>Pick the plan of your choice between third-party &amp; comprehensive plans</p>
        <p><strong>Step 5: </strong>Provide your personal information and move ahead.&nbsp;</p>
        <p><strong>Step 6:</strong> Lastly, your bike insurance premium will be displayed. It&rsquo;s that simple!</p>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">Benefits of Bike Insurance Calculator
        </h2>
      </div>
      <div class="ins-answer pt-10">
        <p>An online two-wheeler insurance calculator is a highly useful tool that comes with several benefits.
        </p>
        <ul>
          <li>It lets you compare the offers from different insurers before buying the policy.</li>
          <li>It helps you get familiar with the features and benefits of various plans thereby letting you choose the
            best bike insurance policy for your vehicle.&nbsp;</li>
          <li>A bike insurance calculator makes buying two-wheeler insurance online a time-saving process as you
            don&rsquo;t have to visit any insurance company offices.</li>
          <li>It helps you be prepared with the required documents beforehand with no involvement of any third person
            or an agent, the premiums calculated are impartial.&nbsp;</li>
          <li>A two wheeler vehicle insurance premium calculator is a simple, hassle-free and convenient tool that you
            can use from anywhere, be it from home or any other place.&nbsp;</li>
        </ul>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">Two Wheeler Insurance Calculator for New and Old Bikes
        </h2>
      </div>
      <div class="ins-answer pt-10">
        <p class="pt-10">The process to calculate insurance premiums for old and new two-wheelers also differs. Here
          are some important points you should know:
        </p>

        <h3 class="ins-heading pt-10">Renewing Bike Insurance for your Old Bike
        </h3>
        <p class="pt-10">In this case, a bike insurance calculator helps you check if you have any reduction in the
          premium. As the age of the bike affects the premium amount, this becomes a crucial factor for evaluation.
          The older the bike, the lesser the premium. And, buying bike insurance for your old bike usually involves
          the process of entering the details of your existing policy before you proceed. Details that are need for
          calculating old bike insurance premiums are:
        </p>
        <ul>
          <li>1. Model, variant and age of the two-wheeler</li>
          <li>2. Existing insurance policy details, if any</li>
          <li>3. No Claim Bonus details</li>
        </ul>
        <h3 class="ins-heading pt-10">Purchasing Bike Insurance for your New Bike
        </h3>
        <p class="pt-10">Buying a new bike involves thorough research and evaluation. The same should be the case when
          it comes to protecting your brand-new bike with a bike insurance plan. And, for getting a quick quote, just
          enter the details of your new ride, including the make & model, registration number, manufacture details,
          and more, and derive your bike insurance premium amount instantly. Here are the details needed for
          calculating a new bike’s insurance premiums:
        </p>
        <ul>
          <li>1. Model and variant of the two-wheeler</li>
          <li>2. Year of manufacture </li>
          <li>3. Location of bike registration</li>
        </ul>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">Comprehensive Bike Insurance Premium Calculator
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p>Here are the important features that are used to calculate the insurance premiums for bikes and
          two-wheelers in the case of comprehensive insurance:
        </p>
        <ol>
          <li>Own Damage: Damage to the policyholder&rsquo;s vehicle is covered under comprehensive bike insurance.
          </li>
          <li>Insured Declared Value (IDV): IDV refers to the maximum amount of insurance claim that a policyholder is
            eligible to receive, which is dependent on the current value of the bike or two-wheeler.</li>
          <li>Add-on Covers: You can choose to buy add-on covers on top of your base insurance plan for increased
            protection. Examples of add-ons include bike theft cover or <a
              href="https://www.bajajfinservmarkets.in/discover/journals/blogs/insurance/what-is-a-zero-depreciation-cover-in-bike-insurance/">zero
              depreciation cover in bike insurance</a>.</li>
          <li>No Claim Bonus: No Claim Bonus is a special discount provided to policyholders who do not make any
            claims during a given policy term (year).</li>
          <li>Third-Party Coverage: Apart from providing own damage cover, a comprehensive insurance plan also
            includes coverage for third party damages</li>
          <li>Brand and Model of Bike: Finally, the model and brand of your bike also determine how comprehensive
            insurance premiums are calculated.</li>
        </ol>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">Third-Party Insurance Premium Calculator
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p>Here are the important features that are used to calculate the insurance premiums for bikes and
          two-wheelers in the case of a third-party insurance premium calculator:
        </p>
        <ol>
          <li>Third-party coverage: This insurance only provides third party coverage and insurance premiums are based
            on this singular feature.</li>
          <li>Engine Capacity: Another factor that affects third-party premiums is the engine capacity of the bike or
            two-wheeler.</li>
          <li>Add-on Covers: You can also choose to buy add-on covers on top of your base third-party insurance plan.
          </li>
        </ol>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">List of Bike Insurance Providers we are Partnered With:
        </h2>
      </div>
      <div>
        <div class="">
          <h4 class="ins-heading pt-10">Bajaj Allianz Car Insurance
          </h4>
        </div>
        <div class="" role="img" aria-label="bajaj"><img class="imgInsProvider1" alt="Bagic"
            src="./assets/img/svg/BAGIC-LOGO.svg"> <img class="darkimgInsProvider" alt="Bagic"
            src="./assets/img/svg/dark-bagic-logo.svg"> </div>
        <div class="ins-answer pt-10">Bajaj Allianz Car Insurance is a reliable product offered by Bajaj Allianz, a
          collaboration between Bajaj Finserv Limited and Allianz SE. With their profound expertise in the general
          insurance industry, their products are designed to meet the unique needs of customers. Bajaj Allianz Car
          Insurance is equipped with great features and value-added benefits, so customers can get better value for
          money.
        </div>
        <!-- <div class="verticalBar"></div> -->
        <div class="col-md-12 no-pad">
          <h4 class="ins-heading pt-10">Acko General Insurance
          </h4>
        </div>
        <div class="mobile-divs-center">
          <img class="img-insProvider-acko" alt="acko" src="./assets/img/svg/acko.svg">
        </div>
        <div class="ins-answer pt-10 bottom-20 no-pad mob-bottom-70 acko-top">Acko General Insurance, with its a
          different approach, makes buying insurance easy and quick! The plans are well-designed for the customer's
          needs. It offers inexpensive plans and a range of add-on covers to enhance the plans as per customer
          requirements.
        </div>
      </div>
    </div>
  </div>
  <input id="tab-two-bike" type="radio" name="grp2" />
  <label for="tab-two-bike">Comparison</label>
  <div id="comparison" class="home-tab-content vehicleComparison">
    <div class="">
      <h2 class="ins-heading pt-10">How to Compare Two Wheeler Insurance Plans
      </h2>
    </div>
    <div class="ins-answer pt-10 margin6">
      <p>Online bike insurance calculator has made it easier for you to calculate the bike insurance in minutes. By
        entering just a few important details, the calculator displays the premium amount payable by you, making it
        easier for you to gauge your total investment towards the <a class="link-desc" target="_blank"
          href="https://www.bajajfinservmarkets.in/insurance/motor-insurance/two-wheeler-insurance.html">bike
          insurance policy</a>.
        <br>Follow these quick tips to keep in mind while comparing bike insurance quotes to get the right plan:
      </p>
      <ul>
        <li>The type of plan remains a crucial factor that should be considered when picking a two-wheeler insurance
          plan.
        </li>
        <li>While you do so, don’t forget to examine factors like the features and benefits of the plan. This would
          help in making the right decision.
        </li>
        <li>It is also very important to check the premium amount payable. As premium payment is a regular
          transaction, it is important to consider this aspect, so it does not become a financial burden.
        </li>
        <li>Check add-on covers such as zero depreciation bike insurance or <a class="link-desc" target="_blank"
            href="https://www.bajajfinservmarkets.in/discover/journals/blogs/insurance/what-is-a-zero-depreciation-cover-in-bike-insurance/">bike’s
            roadside assistance</a> cover made available with the bike insurance plan, so you can enhance your
          protection against damages.
        </li>
        <li>The Claim Settlement Ratio of the insurer is another crucial factor that needs to be considered when
          buying a plan. The higher the ratio, the greater is the chance of your claims being accepted.
        </li>
      </ul>
    </div>
    <h2 class="ins-heading pt-10 bottom-20">Factors Determining Bike Insurance Premium
    </h2>
    <div class="blocks">
      <div class="d-flex-blocks">
        <div class="img-div-height">
          <span role="Age of the bike" class=""><img class="" alt="Age of the bike"
              src="./assets/img/svg/Vehicle Age.svg"></span>
        </div>
        <h3 class="img-label">Age of the bike
        </h3>
        <div class="offer-desc">Your vehicle’s age is a crucial factor used to determine the Insured Declared Value
          set by the insurer. This makes
          it a key factor in deciding the bike insurance premium.
        </div>
        <hr class="landing-hr">
      </div>
      <div class="d-flex-blocks">
        <div class="img-div-height">
          <span role="Type of plan" class=""> <img class="" alt="Type of plan"
              src="./assets/img/svg/Type of Coverage.svg"> </span>
        </div>
        <h3 class="img-label">Type of plan
        </h3>
        <div class="offer-desc">Whether you choose a third-party bike insurance or a comprehensive plan, the premium
          amount varies. While comprehensive
          two-wheeler insurance is the most recommended plan, with extensive coverage for third-party and own damage,
          the
          premium for this plan is relatively higher.
        </div>
        <hr class="landing-hr">
      </div>
      <div class="d-flex-blocks">
        <div class="img-div-height">
          <span role="Location" class=""><img class="" alt="Location" src="./assets/img/svg/Geographic Location.svg">
          </span>
        </div>
        <h3 class="img-label">Location
        </h3>
        <div class="offer-desc">Your geographical location plays a vital role in determining the two-wheeler insurance
          premium as the customers living
          in localities with higher probability of theft and damage are charged with a higher premium.
        </div>
        <hr class="landing-hr">
      </div>
      <div class="d-flex-blocks">
        <div class="img-div-height">
          <span role="Riders" class=""> <img class="" alt="Riders" src="./assets/img/svg/Add-on Covers.svg"></span>
        </div>
        <h3 class="img-label">Riders
        </h3>
        <div class="offer-desc">Add-on covers are an essential enhancement for your financial coverage. Your total
          bike insurance premium is also
          affected by the additional rider options you select as you have to pay an additional premium for them.
        </div>
        <hr class="landing-hr">
      </div>
      <div class="d-flex-blocks">
        <div class="img-div-height">
          <span role="Engine capacity" class=""> <img class="" alt="Engine capacity"
              src="./assets/img/svg/Type of Engine.svg"> </span>
        </div>
        <h3 class="img-label">Engine capacity
        </h3>
        <div class="offer-desc">Your bike’s engine capacity is also a very important factor that helps determine the
          premium of your bike insurance
          policy. Greater the engine capacity, higher is the premium.
        </div>
        <hr class="landing-hr">
      </div>
    </div>
    <div class="">
      <h2 class="ins-heading pt-10">How to Reduce Bike Insurance Premiums
      </h2>
    </div>
    <div class="ins-answer pt-10 margin6">
      <p>Bike insurance premium rates may vary across different insurance companies. However, you can always take the
        necessary measures to save on the two-wheeler insurance premiums that you will pay for the financial coverage.
        <br>Here are some tips to reduce the bike insurance premiums:
      </p>
      <ul>
        <li class="bottom-10">
          <h3 class="display-inline">Choose relevant add-on covers </h3>
          <div class="top-spc-5">Add-on covers are an essential addition to your bike insurance plan. Having said
            that, it is also very important to pick relevant riders to ensure you don’t spend on non-essential ones.
          </div>
        </li>
        <li class="bottom-10">
          <h3 class="display-inline">Install anti-theft devices </h3>
          <div class="top-spc-5">Some insurers allow you to save on your premium if your vehicle has an anti-theft
            device installed on your bike.</div>
        </li>
        <li class="bottom-10">
          <h3 class="display-inline">Pay for minor damages from your pocket</h3>
          <div class="top-spc-5"> Avoid filing claims for small damages to enjoy NCB (No Claim Bonus). If you are
            wondering what’s
            <a class="link-desc" target="_blank"
              href="https://www.bajajfinservmarkets.in/discover/journals/blogs/insurance/what-is-ncb-in-two-wheeler-insurance/">NCB
              in bike insurance,</a> NCB is a discount that insurers typically offer after every claim-free year
          </div>
        </li>
        <li class="bottom-10">
          <h3 class="display-inline">Opt for long-term policies </h3>
          <div class="top-spc-5">Long-term bike insurance policies save you the hassle of renewing your policy
            annually.
          </div>
        </li>
      </ul>
    </div>
  </div>
  <input id="tab-three-bike" type="radio" name="grp2" />
  <label for="tab-three-bike">FAQS</label>
  <div id="faqs" class="home-tab-content vehicleFaq faqs">
    <div class="faq-details">
      <h3 #ques1 (click)="openAnswer(ques1)" class="ques">When will I get my bike insurance policy if I buy it online?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans1" class="ans">Various insurers send your bike insurance policy document’s soft copy on the registered
        email id immediately after you pay your two-wheeler insurance premium online.
      </p>
    </div>
    <div class="faq-details">
      <h3 #ques2 (click)="openAnswer(ques2)" class="ques">Why is it good to get a two-wheeler insurance quote online?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans2" class="box ans col-xs-12 col-sm-12 col-md-12">Getting a two-wheeler insurance quote online does not
        just save you time and hassle, but also lets you save on the extra expenses incurred on middlemen or agents.
      </p>
    </div>
    <div class="faq-details">
      <h3 #ques3 (click)="openAnswer(ques3)" class="ques">What is IDV for bike insurance?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans3" class="box ans col-xs-12 col-sm-12 col-md-12">IDV for bike insurance means the current market value
        of the vehicle. It corresponds to the maximum sum assured fixed on the vehicle by the insurer. It is paid
        against the total loss or theft of the bike.
      </p>
    </div>
    <div class="faq-details">
      <h3 #ques4 (click)="openAnswer(ques4)" class="ques">Is the bike insurance calculator accurate?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans4" class="box ans col-xs-12 col-sm-12 col-md-12">Yes, as long as you input the right details about
        your vehicle in the two-wheeler insurance premium calculator, you will get an accurate quote.
      </p>
    </div>
    <div class="faq-details">
      <h3 #ques5 (click)="openAnswer(ques5)" class="ques">How can I select the best two-wheeler insurance plan for my
        bike?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans5" class="box ans col-xs-12 col-sm-12 col-md-12">
        You can get the best bike insurance plan for your vehicle by using the two-wheeler insurance premiums
        calculator to check the premiums and quotes of various insurance plans. You should also browse different
        insurance websites before settling on buying your insurance plan. </p>
    </div>
  </div>
</div>